// CartDropdown.jsx
import { Badge, Button, Dropdown, Spin, message, Popconfirm } from "antd";
import { useContext, useEffect, useState } from "react";
import { IoBagOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Link } from "react-router-dom";
import { UserContext } from "../../context/userContext";
import { getProductsDetails } from "../../services/productsDetails/productsDetails";
import { patchUserCart } from "../../services/user/user";
import { formatNumber } from "../../helper/fomartNum";
import { priceNew } from "../../helper/priceNew";
import "./CartDropdown.scss";

function CartDropdown() {
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const [cartProducts, setCartProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const fetchCartProducts = async () => {
      if (!currentUser?.cart || currentUser.cart.length === 0) {
        setCartProducts([]);
        return;
      }

      setLoading(true);
      try {
        const results = await Promise.all(
          currentUser.cart.map((id) => getProductsDetails(id))
        );

        const fetchedProducts = results.map((r) => r[0]);

        // Merge giữ stock cũ nếu có
        const mergedProducts = fetchedProducts.map((p) => {
          const existing = cartProducts.find((cp) => cp.id === p.id);
          return existing ? { ...p, stock: existing.stock } : p;
        });

        setCartProducts(mergedProducts);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };

    fetchCartProducts();
  }, [currentUser]);

  const handleRemove = async (productId) => {
    try {
      const newCart = currentUser.cart.filter((id) => id !== productId);
      await patchUserCart(currentUser.id, newCart);
      setCurrentUser({ ...currentUser, cart: newCart });

      messageApi.success("Đã xóa sản phẩm khỏi giỏ hàng");
    } catch (err) {
      console.error(err);
      messageApi.error("Xóa sản phẩm thất bại, thử lại sau");
    }
  };

  const totalPrice = cartProducts.reduce(
    (acc, p) => acc + priceNew(p.price_old, p.sales),
    0
  );

  // Kiểm tra có sản phẩm đã bán không
  const hasSoldOut = cartProducts.some((p) => p.stock === false);

  const handleCheckoutClick = () => {
    if (hasSoldOut) {
      messageApi.warning(
        "Một hoặc nhiều sản phẩm trong giỏ hàng đã hết, vui lòng loại bỏ trước khi thanh toán."
      );
      return;
    }
    // Nếu không có sản phẩm đã bán, chuyển đến trang checkout
    window.location.href = "/checkoutCart";
  };

  const overlayContent = (
    <div className="cart-dropdown">
      <div className="cart-title">Giỏ hàng</div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 20 }}>
          <Spin />
        </div>
      ) : cartProducts.length === 0 ? (
        <div className="cart-none">Giỏ hàng trống</div>
      ) : (
        <>
          {cartProducts.map((p) => {
            const ThumbWrapper = p.stock ? Link : "div";

            return (
              <div key={p.id} className="cart-item">
                <ThumbWrapper
                  to={p.stock ? `products/${p.id}` : undefined}
                  className="cart-thumb-wrapper"
                >
                  <img
                    src={p.thumbnail1}
                    alt={p.title}
                    className="cart-thumb"
                  />
                  {!p.stock && <div className="sold-tag">ĐÃ BÁN</div>}
                </ThumbWrapper>

                <div className="cart-info">
                  <div className="cart-name">{p.title}</div>

                  <div className="cart-price">
                    <del className="price-old">{formatNumber(p.price_old)}</del>
                    <div className="price-new">
                      {formatNumber(priceNew(p.price_old, p.sales))}đ
                    </div>
                  </div>

                  <div className="cart-size">{p.size}</div>

                  <Popconfirm
                    title="Bạn có chắc muốn xóa?"
                    onConfirm={() => handleRemove(p.id)}
                    okText="Có"
                    cancelText="Hủy"
                  >
                    <RiDeleteBin6Line
                      className="cart-icon-delete"
                      style={{ cursor: "pointer" }}
                    />
                  </Popconfirm>
                </div>
              </div>
            );
          })}

          <div className="cart-money">
            Tổng tiền: {formatNumber(totalPrice)}đ
          </div>

          <div className="cart-sub">
            Phí vận chuyển sẽ được tính khi bạn thanh toán
          </div>

          <div className="cart-btn">
            <Button
              className="cart-btn-payment"
              type="primary"
              onClick={handleCheckoutClick}
              disabled={cartProducts.length === 0}
            >
              Thanh toán
            </Button>

            <Link to="/cart">
              <Button className="cart-btn-watch">Xem giỏ hàng</Button>
            </Link>
          </div>
        </>
      )}
    </div>
  );

  return (
    <>
      {contextHolder}
      <Dropdown
        overlay={overlayContent}
        trigger={["hover"]}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        placement="bottomRight"
      >
        <Badge count={cartProducts.length} overflowCount={99}>
          <IoBagOutline className="login-icon" style={{ cursor: "pointer" }} />
        </Badge>
      </Dropdown>
    </>
  );
}

export default CartDropdown;
